import { CoinMarketCapTokenData } from '@crypto-trading/common/browser';
import { ApiClientManager } from '@/utils/api-client-factory';

/**
 * Token Metadata API functions
 */
export const getTokenMetadata = async (
  symbol: string
): Promise<CoinMarketCapTokenData | null> => {
  const metadata = await ApiClientManager.getTokenMetadataClient().getTokenMetadata(symbol);
  console.log('metadata', metadata);
  return metadata;
};
